/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Gps_CurrentInputs */

const vi_vehicle_gps_current = /** @type {(inputs: Vehicle_Gps_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Định vị hiện tại`)
};

/**

* @param {Vehicle_Gps_CurrentInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vehicle_gps_current = /** @type {((inputs?: Vehicle_Gps_CurrentInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Gps_CurrentInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vehicle_gps_current(inputs)
});